import { MDBAlert, MDBBtn, MDBIcon } from "mdbreact"
import React from "react"
import { Link } from "react-router-dom"
import { Card, CardBody, Col, Collapse, Container, Form, Input, Label, Media, Row, Table } from "reactstrap"
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import _valid from "../../validations"
import { TIEMPO_MOSTRAR_ERROR } from "../../ayudas/constantes"

export default class formArea extends React.Component {

    constructor(props) {
        super(props);

        this.apiRest = new ApiRest(props);

        this.state = {
            registro: _valid(this.props.location.registro) ? this.props.location.registro : {
                id: null,
                nombre: null,
                descripcion: null
            },
            colapsar: true,
            colapsarAsociarCategoria: true,
            colapsarAsociarEmpresa: true,
            camposRequeridos: [],
            categorias: [],
            empresas: [],
            proveedores: []
        };
        this.almacenarRegistro = this.almacenarRegistro.bind(this);
        this.actualizarValores = this.actualizarValores.bind(this);
    }

    componentDidMount() {
        
    }

    colapsar() {
        this.setState(estadoAnterior => ({ colapsar: !estadoAnterior.colapsar }));
    }

    actualizarValores = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            registro: { ...estadoAnterior.registro, [name]: value }
        }));
    }

    almacenarRegistro = () => {

        if (this.datosRegistroValidos()) {
            const{
                registro
            } = this.state
            if(_valid(registro.id)){
                this.apiRest.put('/modificacionAreaTrabajo/'+registro.id,registro).then(respuesta => {
                    if (respuesta.exitoso) {
                        toastr.success('Datos actualizados exitosamente!');
                        this.props.history.replace('/areaTrabajo');
                    }else {
                        toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                    }
                });
            }else{
                this.apiRest.post('/getAreaTrabajo',registro).then(respuesta => {
                    if (respuesta.exitoso) {
                        toastr.success('Datos almacenados exitosamente!');
                        this.props.history.replace('/areaTrabajo');
                    }else {
                        toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                    }
                });
            }
        }
    }

    datosRegistroValidos() {
        const {
            nombre,
            descripcion
        } = this.state.registro;

        let contador = 0

        const { camposRequeridos } = this.state;

        if (!_valid(nombre)) {
            camposRequeridos.push("nombre");
        } else {
            contador += 1;
        }
        if (!_valid(descripcion)) {
            camposRequeridos.push("descripcion");
        } else {
            contador += 1;
        }

        this.setState({ camposRequeridos: camposRequeridos });
        setTimeout(() => this.setState({ camposRequeridos: [] }), TIEMPO_MOSTRAR_ERROR);

        if (contador === 2) {
            return true
        } else {
            return false;
        }
    }

    render() {
        const {
            registro,
            colapsar,
            camposRequeridos,
        } = this.state;

        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Inventario" breadcrumbItem="Ubicación Area de Trabajo" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <Link onClick={() => this.colapsar()} className="text-dark" to="#">
                                            <div className="p-4">
                                                <Media className="d-flex align-items-center">
                                                    <div className="me-3">
                                                        <i className="uil uil-receipt text-primary h2"></i>
                                                    </div>
                                                    <div className="flex-1 overflow-hidden">
                                                        <h5 className="font-size-16 mb-1">Ubicaci&oacute;n Area de Trabajo</h5>
                                                        <p className="text-muted text-truncate mb-0">Por favor, proporciona los datos.</p>
                                                    </div>
                                                    <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                </Media>
                                            </div>
                                        </Link>
                                        <Collapse isOpen={colapsar}>
                                            <div className="p-4 border-top">
                                                <Form>
                                                    <div>
                                                        <Row>
                                                            <Col lg={6}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="nombre" className="form-label">
                                                                        Nombre
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.nombre}
                                                                        onChange={this.actualizarValores}
                                                                        name="nombre"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresa el nombre"
                                                                        required={true}
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={6}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="descripcion" className="form-label">
                                                                        Descripcion
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.descripcion}
                                                                        onChange={this.actualizarValores}
                                                                        name="descripcion"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresa una descripción"
                                                                        required={true}
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                    &nbsp;
                                                    <Row>
                                                        {_valid(camposRequeridos) && camposRequeridos.map((campo, index) => <MDBAlert key={index} color="danger"><strong>{campo}</strong> es requerido.</MDBAlert>)}
                                                    </Row>
                                                </Form>
                                                <Row>
                                                    <Col lg={12} className="text-end">
                                                        <MDBBtn className="waves-effect" color="danger" onClick={() => { this.props.history.replace('/areaTrabajo') }}>
                                                            <MDBIcon icon="fas fa-arrow-left" />{' '}
                                                            Regresar
                                                        </MDBBtn>
                                                        {' '}
                                                        <MDBBtn className="waves-effect" color="success" onClick={() => this.almacenarRegistro()}>
                                                            <MDBIcon icon="fas fa-user-check" /> {' '}
                                                            Guardar
                                                        </MDBBtn>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Collapse>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}